<template>
  <div class="card">
    <div class="card-body">
      <div class="row" v-if="false">
        <div class="col-sm-9">
          <h5 class="card-title">{{ quote.name }}</h5>
        </div>
        <div class="col-sm-3">
          <div class="col-sm-12 mt-4 text-right">
            <button v-if=" false & !quote.approved" @click="deelete" type="button" class="btn btn-danger" style="float:right;margin:5px;"><i
                class="bi bi-trash"></i></button>
          </div>
          <div v-if="false & behavior == 'admin'" class="col-sm-12 mt-4 text-right">
            <button v-if="!quote.approved" @click="aprove" type="button" class="btn btn-warning" style="float:right;margin:5px;"><i
                class="bi bi-check"></i>Accept quote</button>
          </div>
          

        </div>

      </div>


      <div class="row">
        <div :class="behavior == 'user' ? 'col-sm-8' : 'col-sm-12'">
          <div class="row mt-3">
            <div class="col-sm-3 negro">Assessment Method</div>
            <div class="col">{{ quote.serviceType }}</div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-3 negro">Created</div>
            <div class="col">{{ getCreatedDate }}</div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-3 negro">Summary</div>
            <div class="col">{{ quote.resumen }}</div>
          </div>

          <div v-if="!quote.haveResume">
            <div class="row mt-4">
              <div class="col-sm-3 negro">Buildings/Designs</div>
            </div>

            <div class="row">
              <div class="offset-sm-3 col negro">Building:</div>
              <div class="col negro">Class:</div>
              <div class="col negro">Size:</div>
              <div v-if="isJVorDTS" class="col negro">Orientation:</div>
            </div>
            <div class="row" v-for="building in quote.buildings" :key="building.name">
              <div class="offset-sm-3 col">{{ building.name }}</div>
              <div class="col">
                {{ getClassName(building.buildingClass) }}
              </div>
              <div class="col">
                {{
                  building.area == ""
                    ? building.numModules + " mod"
                    : building.area + "m2"
                }}
              </div>
              <div v-if="isJVorDTS" class="col">{{ building.numOrientations }}</div>
            </div>
          </div>

          <div v-else>
            <div class="row mt-4">
              <div class="col-sm-3 negro">Buildings/Designs</div>
            </div>
            <div class="row" v-for="building in quote.buildings" :key="building.name">
              <div class="offset-sm-3 col-md-9">{{ building.resume.name }}, {{ building.resume.orientation }}</div>

              <div class="col-md-12 text-end"
                v-if="building.idBuildingDetail != null || building.idBuildingEnergy != null">
                <p class="text-end">{{ building.resume.percentDiscount }}% discount,
                  <a href="#" @click="getBuildingInfo(building.idBuildingEnergy)"
                    v-if="building.idBuildingEnergy != null">Energy model from previous job</a><br />
                  <a href="#" @click="getBuildingInfo(building.idBuildingDetail)"
                    v-if="building.idBuildingDetail != null">Construction details from previous job</a>
                </p>
              </div>
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-sm-3 negro">Orientations</div>
            <div class="col" v-if="loaded">
              {{ quoteOrientations }}
            </div>
          </div>
          <div class="row mt-4" v-if="quote.listWeatherFiles != ''">
            <div class="col-sm-3 negro">Weather Files</div>
            <div class="col-sm-9" v-if="loaded">
              {{ quote.numWeatherFiles }}
              <span v-if="quote.numWeatherFiles > 0">({{ quote.listWeatherFiles }})</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-3 negro">Climate Zones</div>
            <div class="col-sm-9" v-if="loaded">
              {{ quote.numClimateZones }}
              <span v-if="quote.numClimateZones > 0">({{ quote.climateZones }})</span>
            </div>
          </div>

          <div v-if="loaded && quote.address != ''" class="row mt-4">
            <div class="col-sm-3 negro">Address</div>
            <div class="col-sm-9">
              {{ quote.address }}
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-sm-3 negro">Construction Option</div>
            <div class="col-sm-9">As per drawings</div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-3 negro">Glazing template</div>
            <div class="col-sm-9" v-if="loaded">As per drawings</div>
          </div>
          <div class="row mt-4 mb-3">
            <div class="col-sm-3 negro">Notes</div>
            <div class="col-sm-9" v-if="loaded">
              <p>{{ quote.notes }}</p>
            </div>
          </div>

          <filesQuote v-if="false && loaded" :idQuote="idQuote" :behavior="'user'" />

        </div>

        <div v-if="behavior == 'user'" class="col-sm-4">
          <div class="row mt-4">
            <div class="col-sm-5 negro">Quote Total:</div>
            <div class="col-sm-5 negro" v-if="loaded">${{ quote.total }}</div>
            <div class="col-sm-2 negro text-center" style="font-size:25px;">
              <a href="#" @click="seeQuoteDocument"><i class="bi bi-file-earmark-pdf"></i></a>
            </div>
          </div>

          <div class="row mt-4">
            <p>
              Quotes are generated automatically through our online scoping
              tool, and as such, Modspec reserves the right to refuse service if
              the scope does not align with the intended assessment and provided
              drawings. Please ensure input details are accurate to avoid
              delays.
            </p>
            <p>
              If there is any clarification required for accepted projects,
              Modspec will contact you first via the email address provided.
              Please do not hesitate to contact
              <a href="mailto:commercial@modspec.com.au">commercial@modspec.com.au</a>
              if you have any questions.
            </p>
          </div>
          <div class="row mt-4">
            <div class="col d-grid gap-2">
              <button type="button" class="btn btn-warning" @click="aprove">
                <i class="bx bx-check"></i> Accept quote
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------->
  <button style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlApprovedModal" id="btnOpenApprovedModal">
    Open
  </button>
  <div  class="modal fade" id="mdlApprovedModal" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Accept quote</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12 form-floating mb-3">
              <textarea v-model="mdlApprove.comment" class="form-control" placeholder="Leave a comment here"
                id="mdlComment" style="height: 100px"></textarea>
              <label for="floatingTextarea">Comments</label>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-12">
              <input class="form-check-input" type="radio" id="optUpload" v-model="mdlApprove.option" value="upload" />
              <label class="form-check-label" for="optUpload">
                &nbsp;Upload purchase order
              </label>
            </div>
          </div>

          <div class="row mt-3" v-if="mdlApprove.option == 'upload'">
            <div class="offset-sm-1 col-sm-11">
              <input type="file" class="form-control" @change="handleFileUpload($event)" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-12">
              <input class="form-check-input" type="radio" id="optSign" v-model="mdlApprove.option" value="sign" />
              <label class="form-check-label" for="optSign">
                &nbsp;Sign acceptance
              </label>
            </div>
          </div>

          <div class="row mt-3" v-if="mdlApprove.option == 'sign'">
            <div class="offset-sm-1 col-sm-11">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="grdAccept" :checked="mdlApprove.accept"
                  @change="mdlApprove.accept = !mdlApprove.accept" />
                <label class="form-check-label" for="grdAccept">
                  I accept the quote, terms and conditions
                </label>
              </div>
            </div>
          </div>

          <div class="row mt-3" v-if="mdlApprove.option == 'sign'">
            <div class="offset-sm-1 col-sm-4">Type your name:</div>
            <div class="col-sm-7">
              <input class="form-control italicText" type="text" id="txtSign" v-model="mdlApprove.signature" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <loadingbutton :loading="isLoading" @pressed="approved" :disabled="(!canAccept || isLoading)" buttonText="Accept" />
          <!-- <button
            type="button"
            @click="approved"
            class="btn btn-primary"
            :disabled="!canAccept"
          >
            Accept
          </button> -->
          <button id="btnCloseMdlApprove" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!------------------------------------------------------------------------------------------->
  <button style="display:none;" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlSeeBuilding" id="btnAbrirSeeBuilding">Open</button>
  <div class="modal fade" id="mdlSeeBuilding" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modspec_title-small">Building</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col negro">Building:</div>
                <div class="col negro">Class:</div>
                <div class="col negro">Size:</div>
                <div v-if="isJVorDTS" class="col negro">Orientation:</div>
              </div>
              <div class="row">
                <div class="col">{{ buildingDiscount.name }}</div>
                <div class="col">
                  {{ getClassName(buildingDiscount.buildingClass) }}
                </div>
                <div class="col">
                  {{
                    buildingDiscount.area == ""
                      ? buildingDiscount.numModules + " mod"
                      : buildingDiscount.area + "m2"
                  }}
                </div>
                <div v-if="isJVorDTS" class="col">{{ buildingDiscount.numOrientations }}</div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="btnClosemdlSeeBuilding" data-bs-dismiss="modal"
            @click="closeSeeBuilding">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Se llama QUOte pero actualmente es ASSESSMENT
import data from "../../helpers/data.json";
import loadingbutton from "../../components/global/loading-button.vue";
import filesQuote from "../../components/global/quote-files.vue";

export default {
  name: "quote-cmp",
  components: {
    loadingbutton,
    filesQuote: filesQuote
  },
  props: ["idQuote", "behavior"],
  data: function () {
    return {
      loaded: false,
      quote: { idServiceType: 0, idClient: 0, haveResume: false },
      mdlApprove: {
        comment: "",
        option: "",
        file: null,
        signature: "",
        accept: false,
        ip: "",
      },
      isLoading: false,
      buildingDiscount: ""
    };
  },
  mounted() {
    let self = this;
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        self.mdlApprove.ip = ip;
      });
    if (this.idQuote != null && this.idQuote != 0) this.getQuoteInfo();
  },
  watch: {
    idQuote: function (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.getQuoteInfo();
    },
  },
  methods: {
    setResumeBuildings() {

      this.quote.listWeatherFiles = "";
      if (this.quote.weatherFiles != "") {
        let wfDetail = JSON.parse(this.quote.weatherFiles);
        this.quote.listWeatherFiles = wfDetail[0].wf.join(',');
      }


        let resumen = JSON.parse(this.quote.resume);
        this.quote.resumen = resumen.text;
        let tb = resumen.textBuildings;
        if (tb != null && tb !== '' && tb.length > 0) {
          this.quote.haveResume = true;
          for (let i = 0; i < this.quote.buildings.length; i++) {
            let build = this.quote.buildings[i];
            build.resume = resumen.textBuildings[i]
          }
        }
      


    },
    seeQuoteDocument() {
      let v = this.quote.publicId;
      window.open(this.$vtc.getConfig().urlAPI + "/Quote/Download?k=" + v, "_blank");
    },
    getBuildingInfo(idBuilding) {
      let self = this;
      this.$vtc
        .vtcFetch("/Quote/GetBuilding/?id=" + idBuilding, null)
        .then(function (data) {
          self.buildingDiscount = data;
          document.getElementById('btnAbrirSeeBuilding').click();
        });
    },
    getQuoteInfo() {
      let self = this;
      this.$vtc
        .vtcFetch("/Assessment/GetAssessment/?id=" + this.idQuote, null,'API2')
        .then(function (data) {
          self.quote = data;
          console.log("QUOTE", data);
          self.setResumeBuildings();
          self.loaded = true;
        });
    },
    handleFileUpload(event) {
      this.mdlApprove.file = event.target.files[0];
    },
    returnToClient() { },
    aprove() {
      document.getElementById("btnOpenApprovedModal").click();
    },

    //no usado por el momento
    approved() {
      this.isLoading = true;

      let self = this;
      const formData = new FormData();
      formData.append("idQ", this.idQuote);
      if (this.mdlApprove.option == "upload") {
        formData.append("file", this.mdlApprove.file);
      } else {
        formData.append("signature", this.mdlApprove.signature);
      }
      formData.append("comments", this.mdlApprove.comment);
      formData.append("ip", this.mdlApprove.ip);

      this.$vtc.vtcFetch("/Assessment/Aprove/", formData,'API2').then(
        function (data) {
          console.log("Aprobado",data);

          document.getElementById("btnCloseMdlApprove").click();
          //self.$emit('accepted', self.idQuote)

          self.$emit("accepted", data); //pass the new project created to reditect to.

          self.isLoading = false;
        },
        function error(err) {
          console.log("Aprobado error",err);
          self.isLoading = false;
        }
      );
    },

    //no usado por el momento
    deelete() {
      let self = this;
      if (confirm("Are you sure to delete?")) {
        this.$vtc
          .vtcFetch("/Assessment/Delete/?id=" + this.idQuote, null,'API2')
          .then(function () {
            //self.$router.go(0);
            if (self.behavior == "user") {
              self.$router.push({
                name: "Dashboard",
                params: {},
              });

            }
            else if (self.behavior == "admin") {
              self.$router.push({
                name: "Client",
                params: { id: self.quote.idClient },
              });
            }

          });
      }

    },
    getClassName(classId) {
      return (
        data.construction.find((c) => c.value == classId)?.short_name || ""
      );
    },
    toProject(idp) {
      this.$router.push({
        name: "Project",
        params: { id: idp },
      });
    }
  },
  computed: {
    isJVorDTS() {
      return this.$vtc.isJVorDTS(this.quote.idServiceType);
    },
    getCreatedDate() {
      let d = new Date(this.quote.created);
      return this.$vtc.pasarFechaAYYYYMMDD(d, "-");
    },
    quoteOrientations() {

      if (this.isJVorDTS) {
        let n = 0;
        this.quote.buildings.forEach(function (b) {
          n += b.numOrientations;
        });
        return n;
      } else {
        return this.quote.numOrientations
      }

    },
    canAccept() {
      if (this.mdlApprove.option == "upload") {
        console.log("archivo", this.mdlApprove.file);
        return this.mdlApprove.file != null;
      } else {
        return this.mdlApprove.accept && this.mdlApprove.signature != "";
      }
    },
  },
};
</script>
<style scoped>
.italicText {
  font-style: italic !important;
}

.negro {
  font-weight: bold;
}

.botonesEncabezado {
  margin-left: 20px;
}
</style>
